import React, { memo } from 'react'
import { Card, Heading, Stack, Text, Title } from '@thirstycamel/ui'
import SelfExclusionRequestForm from '../components/SelfExclusionRequestForm'
import FaqSection from '../components/FaqSection'
import LayoutMain from '../layout/LayoutMain'
import { cmsUseNew } from '../utils/cms'
import { selfExclusionFaqs } from '../utils/selfExclusionFaqs.util'

function SelfExclusionPage() {
  return (
    <LayoutMain title="Self Exclusion" containerSize="lg" bg="gray.50">
      <Stack spacing={8} pt={[6, 10]} pb={[8, 12, 16]}>
        <Card bg="white" p={[5, 6]}>
          <SelfExclusionRequestForm />
        </Card>

        <Card bg="white" p={[5, 6]}>
          {cmsUseNew() ? (
            <FaqSection keyName="self-exclusion" variant="light" />
          ) : (
            <Stack spacing={4}>
              <Title fontSize="lg">FAQs</Title>
              {selfExclusionFaqs.map(faq => (
                <Stack key={faq.question} spacing={2}>
                  <Heading fontSize="sm">{faq.question}</Heading>
                  <Text>{faq.answer}</Text>
                </Stack>
              ))}
            </Stack>
          )}
        </Card>
      </Stack>
    </LayoutMain>
  )
}

export default memo(SelfExclusionPage)
